import { Injectable } from '@angular/core'

import { ExternalLinkOpener } from '@ti/core/contracts/external-link-opener'

@Injectable()
export class BrowserExternalLinkOpener extends ExternalLinkOpener {
  public async open(url: string): Promise<void> {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

export const provideBrowserExternalLinkOpener = () => ({
  provide: ExternalLinkOpener,
  useClass: BrowserExternalLinkOpener,
})
